import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/operations'

export default {

  async detail (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/detail', criterias, { headers })
  }
}
